import React, { useCallback, useEffect } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES,
  LearnerEmailBadge,
  selectedRequestSelector,
  setCoursePauseRequestApproveModalStage,
  useApproveRequestMutation,
} from 'features/courseResume';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import GlobalLoader from 'components/GlobalLoader';
import styles from './CoursePauseRequestApproveModalConfirmStage.module.scss';

function CoursePauseRequestApproveModalConfirmStage() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const { mentee } = selectedRequest;
  const {
    user: { email },
  } = mentee;
  const [approveRequest, { isSuccess, error, isLoading: isApproving }] =
    useApproveRequestMutation();

  const handleProceedClick = useCallback(() => {
    if (isApproving) return;

    approveRequest({
      requestId: selectedRequest.id,
    });
  }, [approveRequest, isApproving, selectedRequest.id]);

  const handleBackClick = useCallback(() => {
    dispatch(
      setCoursePauseRequestApproveModalStage(
        COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.notOpen
      )
    );
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        setCoursePauseRequestApproveModalStage(
          COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.success
        )
      );
      cogoToast.success('Course pause request has been successfully approved.');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isApproving} />
      <div className={styles.root}>
        <Icon
          name="help-new"
          className="h2 m-b-xs"
        />
        <div className="h4 m-b-xs">
          Are you sure you want to approve this request?
        </div>
        <div className="m-b-m">
          <LearnerEmailBadge email={email} />
        </div>
        <Tappable
          className={classNames('btn', styles.proceedButton)}
          disabled={isApproving}
          onClick={handleProceedClick}
          noHighlight
        >
          Yes
        </Tappable>
        <Tappable
          className={classNames('btn m-h-xxs', styles.backButton)}
          disabled={isApproving}
          onClick={handleBackClick}
          noHighlight
        >
          No
        </Tappable>
      </div>
    </>
  );
}

export default CoursePauseRequestApproveModalConfirmStage;
